import {useIntl} from "react-intl";
import * as React from "react";
import Users from "../../../../Elements/Icon/Icons/Safemate/solid/Users";
import { Placeholder, StyledButtonMob } from './index';
import { LabelEnum } from '../../LabelEnum';
import UsersEmpty from "@Icons/Safemate/solid/UsersEmpty";
import { CustomerSettings, CustomerSettingsContext } from "@Safemate/Store/settingsProvider";
import { isGx8 } from "@Safemate/DeviceHardwareEnum";

interface EventSetupActionProps{
  noAccess?: boolean;
  deviceId: number;
  custId: number;
  dehaId: number;
  hasRecipient: boolean;
}

const EventSetupAction = ({deviceId, dehaId, custId, hasRecipient, noAccess}: EventSetupActionProps) => {

  const { formatMessage } = useIntl();

  const customerSettings = React.useContext(CustomerSettingsContext) as CustomerSettings;
  const settingsForCustomer = customerSettings[custId];

  let climaxConfig = false;
  if(settingsForCustomer){
    climaxConfig = settingsForCustomer.climaxConfig && isGx8(dehaId);
  }

  if(noAccess) return <Placeholder/>

  return(
    <StyledButtonMob
      disabled={climaxConfig}
      title={climaxConfig ? formatMessage({id: "eventSetupDisabled", defaultMessage: "Event setup for this device is not available"}) : formatMessage({id: LabelEnum.SHOW_EVENT_SETUP, defaultMessage: "Varslingsliste"})}
      onClick={(event) => {
        event.stopPropagation();
        location.hash = `event_setup/${deviceId}`;
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') 
          location.hash = `event_setup/${deviceId}`;
      }}
    >
      {
        !hasRecipient && <UsersEmpty
          size="medium"
          inline
        />
      }
      {
        hasRecipient && <Users
          size="medium"
          inline
        />
      }

    </StyledButtonMob>
  )
}

export default EventSetupAction;
